<template>
  <div class="collapsible-pane" v-bind:class="{ expanded: expanded }">
    <div class="collapsible-header" v-on:click="$emit('toggle', identifier)">
      <p class="header-title">{{ headerTitle }}</p>
      <span class="collapsible-header__arrow">
          <svg width="18px" height="18px">
              <circle cx="9" cy="9" r="8" fill="black" />
              <path d="M5 7 l4 4 l4 -4"></path>
          </svg>
      </span>
    </div>
    <div class="collapsible-contents">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'collapsiblePane',
    props: [
      'identifier',
      'headerTitle',
      'expanded'
    ]
  }
</script>



// WEBPACK FOOTER //
// collapsiblePane.vue?317419a6